module.exports = __webpack_public_path__ + "static/media/dp-logo.b49a8088.png";